export default __webpack_public_path__ + "static/mini-5-5c0e679f6a26f62cfcf109aac57a013e.png";